<kendo-dialog title="{{'_Report_Filter_Save_Template_Popup_Title_' | translate }}" *ngIf="saveDialogOpened" [minWidth]="300" [width]="500"
  (close)="close()" class="cc-dialog-sm">
  <kendo-dialog-messages closeTitle="{{'_General_Button_Close_Text_' | translate }}"></kendo-dialog-messages>
  <div class="mb-3">
    {{'_Report_Filters_Save_Popup_Description_Text_' | translate}}
  </div>

  <div>
    <label> {{'_Report_Filters_Template_Name_Text_' | translate}}<span tabindex="-1" class="required-field">*</span> </label>
      <input class="form-control" #saveName maxlength="200" type="text" name="saveName" [(ngModel)]="templateName" id="templateName" app-no-lead-ws app-filter
      pattern="^((?=[^<>&])[A-Za-z0-9`\s\|!@?#\\$\/%\[\]^_*\(\)~=\{\}:;+'&quot;.\-;,])*$" (change)="nameChanged($event)">
  </div>

  <div class="cc-validation">
    <div  *ngIf="templateNameInUse">
      {{'_Report_Filters_Template_Name_In_Use_Error_Text_' | translate }}
    </div>  
   
    <div *ngIf="templateNameRequired">
      {{'_Report_Filters_Template_Name_Is_Required_Error_Text_' | translate }}
    </div>
  </div>
 

  <kendo-dialog-actions class="cc-btn-panel">
    <button id="saveFilterTmpCancelBtn" class="btn btn-secondary" (click)="clickCancel()" [disabled]="false">{{'_General_Button_Cancel_Text_' | translate }}</button>
    <button id="saveFilterTmpSaveBtn" class="btn btn-primary" (click)="clickSave()" [disabled]="saveDisabled">{{'_General_Save_Changes_Text_' | translate }}</button>
  </kendo-dialog-actions>
</kendo-dialog>
